module.exports = __webpack_public_path__ + "img/jcb.0b914789.svg";